export class GridPosition {
  public readonly row: number;
  public readonly col: number;

  constructor(row: number, col: number) {
    this.row = row;
    this.col = col;
  }

  static add(a: GridPosition, b: GridPosition): GridPosition {
    return new GridPosition(a.row + b.row, a.col + b.col);
  }
}
